import React, {type RefObject} from 'react';

import appConfig from '@/config/appConfig.typed';
import domService from '@/services/domService';

import HealthWarningAlternativeTop from './components/HealthWarningAlternativeTop';
import {WARNING_BANNERS_TYPES} from './hwConsts';
import {setHwHeightCssVariable} from './hwUtils';

interface WarningBannersTopProps {
    source: string;
    className?: string;
    containerRef?: RefObject<HTMLElement | null>;
}

const getBanner = (source: string) => {
    const warningBanners = appConfig.getWarningBanners();
    const banners = warningBanners?.filter(
        (b: {type: string; pages?: string[]}) =>
            b.type === WARNING_BANNERS_TYPES.HEALTH_WARNING_ALTERNATIVE_TOP && b.pages?.some((page) => page === source)
    );
    const banner = banners.length ? banners[0] : null;

    return banner;
};

const WarningBannersTop = ({source, className, containerRef}: WarningBannersTopProps) => {
    const banner = getBanner(source);

    if (!banner) {
        const container = containerRef ? containerRef.current : domService.getRoot();

        if (container) setHwHeightCssVariable(container, 0);

        return null;
    }

    return <HealthWarningAlternativeTop className={className} {...banner} containerRef={containerRef} />;
};

export default WarningBannersTop;
